import { cva as e } from "class-variance-authority";
// src/design/tabs/style.ts
var t = e("relative w-full", {
	variants: { orientation: {
		horizontal: "flex flex-col",
		vertical: "flex flex-row gap-4"
	} },
	defaultVariants: { orientation: "horizontal" }
}), n = e("relative flex", {
	variants: {
		variant: {
			line: "border-b border-border bg-back rounded-sm px-1.5 py-1",
			enclosed: "border-b !border-border",
			pills: "bg-muted p-1 rounded-lg",
			solid: "gap-1"
		},
		orientation: {
			horizontal: "flex-row",
			vertical: "flex-col border-r !border-border"
		},
		size: {
			sm: "gap-1",
			md: "gap-2",
			lg: "gap-3"
		}
	},
	compoundVariants: [{
		variant: "pills",
		orientation: "horizontal",
		className: "w-fit"
	}, {
		variant: "pills",
		orientation: "vertical",
		className: "border-0"
	}],
	defaultVariants: {
		variant: "line",
		orientation: "horizontal",
		size: "md"
	}
}), r = e([
	"relative inline-flex items-center justify-center",
	"font-medium",
	"cursor-pointer",
	"disabled:opacity-50 disabled:cursor-not-allowed",
	"focus-ring",
	"whitespace-nowrap",
	"z-10",
	"group"
], {
	variants: {
		variant: {
			line: [
				"border-b-2 -mb-[1px] !border-transparent rounded-sm",
				"text-muted-foreground text-leading-1",
				"transition-colors duration-slow ease-standard",
				"hover:bg-back-hover hover:font-medium hover:text-foreground",
				"data-[selected]:text-primary",
				"data-[selected]:font-semibold"
			],
			enclosed: [
				"border !border-transparent rounded-t-md",
				"text-muted-foreground bg-transparent",
				"transition-all duration-slow ease-standard",
				"hover:bg-muted",
				"data-[selected]:bg-back",
				"data-[selected]:text-foreground",
				"data-[selected]:!border-border",
				"data-[selected]:!border-b-transparent",
				"data-[selected]:font-semibold"
			],
			pills: [
				"rounded-md",
				"text-muted-foreground",
				"transition-colors duration-normal ease-enter",
				"not-data-[selected]:hover:bg-back-hover",
				"not-data-[selected]:hover:text-foreground",
				"data-[selected]:text-primary"
			],
			solid: [
				"rounded-md",
				"text-muted-foreground bg-transparent",
				"transition-colors duration-normal ease-enter",
				"not-data-[selected]:hover:bg-secondary",
				"not-data-[selected]:hover:text-foreground",
				"data-[selected]:text-primary-foreground"
			]
		},
		size: {
			sm: "px-3 py-1 text-sm",
			md: "px-4 py-2 text-sm",
			lg: "px-5 py-3 text-md"
		},
		orientation: {
			horizontal: "",
			vertical: "w-full justify-start"
		}
	},
	compoundVariants: [{
		variant: "line",
		orientation: "vertical",
		className: "border-b-0 border-r-2"
	}, {
		variant: "enclosed",
		orientation: "vertical",
		className: "rounded-t-none rounded-l-md border-b data-[selected]:!border-r-transparent"
	}],
	defaultVariants: {
		variant: "line",
		size: "sm",
		orientation: "horizontal"
	}
}), i = e([
	"absolute",
	"transition-all duration-slow ease-enter",
	"will-change-[width,height,transform,left,top]",
	"z-0"
], {
	variants: {
		variant: {
			line: "bg-primary rounded-full",
			enclosed: "hidden",
			pills: "bg-back shadow-sm rounded-md",
			solid: "bg-primary rounded-md"
		},
		orientation: {
			horizontal: "",
			vertical: ""
		}
	},
	compoundVariants: [
		{
			variant: "line",
			orientation: "horizontal",
			className: "h-0.5 bottom-0 w-[var(--width)] left-[var(--left)]"
		},
		{
			variant: "line",
			orientation: "vertical",
			className: "w-0.5 right-0 h-[var(--height)] top-[var(--top)]"
		},
		{
			variant: "pills",
			className: "w-[var(--width)] h-[var(--height)] left-[var(--left)] top-[var(--top)]"
		},
		{
			variant: "solid",
			className: "w-[var(--width)] h-[var(--height)] left-[var(--left)] top-[var(--top)]"
		}
	],
	defaultVariants: {
		variant: "line",
		orientation: "horizontal"
	}
}), a = e([
	"mt-2",
	"focus-ring",
	"data-[selected]:block"
], {
	variants: {
		variant: {
			line: "",
			enclosed: "border !border-border border-t-0 rounded-b-md p-4 bg-back",
			pills: "",
			solid: ""
		},
		size: {
			sm: "text-sm",
			md: "text-base",
			lg: "text-md"
		},
		orientation: {
			horizontal: "",
			vertical: "mt-0"
		}
	},
	defaultVariants: {
		variant: "line",
		size: "md",
		orientation: "horizontal"
	}
}), o = () => ({
	root: t,
	list: n,
	trigger: r,
	indicator: i,
	content: a
});
export { a as contentStyles, o as getStyles, i as indicatorStyles, n as listStyles, t as rootStyles, r as triggerStyles };

//# sourceMappingURL=style.js.map